import React, { useState, useEffect , useRef } from 'react';
import { withRouter } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import Header from '../Header';
import Footer from '../Footer';
import 'react-datepicker/dist/react-datepicker.css';

import BasicInfoTab from './PatientRegistrationComponents/BasicInfoTab';
import Address from './PatientRegistrationComponents/AddressTab';
import Contact from './PatientRegistrationComponents/ContactTab';
import InsuranceTab from './PatientRegistrationComponents/InsuranceTab';

import {CommonConstant} from '../Utils/CommonConstant';
import { submitIconTooltip } from '../CommonComponent/CommonIconTooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import setAllDataInJson from './GetAndSetScreenData/SetAllDataInJson'
import PWRService from '../../RequestConfigAndConstants/PWRService';
import ValidationPopup from '../Validation/ValidationPopup';
import { ToastContainers } from '../CommonComponent/ToastNotification';
import { ToastMessageNotification } from '../CommonComponent/ToastNotification';

let toastMessages = CommonConstant.toastMessages
let pwrService = new PWRService();
function PatientRegistration(props) {
    
    const basicInfoRef = useRef();
    const addressRef = useRef();
    const validationPopupRef = useRef();
    const contactRef = useRef();
    const insuranceRef = useRef();

    const [basicInfoData, setBasicInfoData] = useState();
    const [addressData, setAddressData] = useState([]);
    const [contactData, setContactData] = useState([]);
    const [contactDataTemp, setContactDataTemp] = useState([]);
    const [insuranceDataTemp, setInsuranceDataTemp] = useState([]);
    const [insuranceData, setInsuranceData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    let requestJSON = {};
    let contactDataFormat =[];
    let insuranceDataFormat =[];

    useEffect(()=>{
        let isMounted = true;  
        setIsLoading(true);
        localStorage.setItem("licence_number",props.match.params.id);

        let requestLicenceJSON={
            "pmsSource": "RX30",
            "storeIdentifier": props.match.params.id,
            "licensedFeature": "PATIENT_WEB_INTAKE"
           }
           
           pwrService.validateLicenceAPI(requestLicenceJSON).subscribe(res=>{
               if(res !== undefined && res !== null && res.status !== undefined && res.status !== "" && res.data !== null && res.data !== undefined && res.data.isLicensed !== null && res.data.isLicensed !== undefined && res.data.isLicensed !== "")
               {
                   if(!res.data.isLicensed)
                   {
                     props.history.push("/access-denied");
                     if (isMounted)
                        setIsLoading(false);
                   }
               }
               else{
                props.history.push("/access-denied");
               }

               if (isMounted)
                setIsLoading(false);
           });


    //    if(localStorage.getItem("isValidated") !== true)
    //    {
    //        if (localStorage.getItem("licence_number") !== '101542') {
    //            localStorage.setItem("isValidated",false);
    //            props.history.push("/access-denied");
    //        }
    //        else{
    //             localStorage.setItem("isValidated",true);
    //             props.history.push("/");
    //        }
    //    }
    return () => { isMounted = false };
    },[props.match.params.id,props.history]);


    useEffect(() => {
        // localStorage.setItem("PMSSource", "RX30");
        // if (document.referrer !== "" && document.referrer.includes("https://www.computer-rx.com/")) {
        //     localStorage.setItem("PMSSource", "CRX");
        // }

         // if (window.parent.location.href !== "" && window.parent.location.href.includes("http://localhost:3000/PRW")) {
        //     localStorage.setItem("PMSSource", "CRX");
        // }

        localStorage.setItem("PMSSource", "RX30");
       

    }, []);


    const validateAndSave = () => {
        let isValid = true;
    
        if(addressRef.current !== undefined && !addressRef.current.validateAddress())
            isValid=false;
        
        if(basicInfoRef.current !== undefined && !basicInfoRef.current.validateBasicInfo())
            isValid=false;

        if(isValid){              
            formatJsonAndSave();
        }
        else{
            ToastMessageNotification(toastMessages.FILL_MANDATORY_FIELDS);
        }
    }

    const formatContactData = () =>{
        let contactId='';
        if(contactDataTemp !== undefined && contactDataTemp !== null && contactDataTemp !== [] && contactDataTemp.length !== 0 && contactDataTemp[0].id !== undefined && contactDataTemp[0].id !== "")
            contactId = contactDataTemp[0].id 
            let newArr = [];
            if(contactData !== undefined && contactData !== null && contactData !== []  && contactData.length !== 0)
            {
                // newArr = contactData;
                newArr.push(...contactData.map(obj => ({...obj})));
                let isIdMatch = false;
                newArr.forEach((item,index)=>{
                    if(item.id !==undefined && item.id !=="" && item.id === contactId && contactDataTemp[0]!==undefined && contactDataTemp[0] !== null && contactDataTemp[0] !=="")
                    {
                        newArr[index] = contactDataTemp[0];
                        isIdMatch = true;
                    }
                });
                if(!isIdMatch)
                    newArr.push(...contactDataTemp.map(obj => ({...obj})));
                    // newArr = [...contactDataTemp]
            }
            else{
                newArr.push(...contactDataTemp.map(obj => ({...obj})));
            }
        contactDataFormat=newArr;
        setContactData(contactDataFormat)
        if(contactRef.current !== undefined )
            contactRef.current.resetContactOnClickOfSubmit()
        formatInsuranceData();
    }

    const formatInsuranceData = () =>{
        let insuranceId='';
        if(insuranceDataTemp !== undefined && insuranceDataTemp !== null && insuranceDataTemp !== [] && insuranceDataTemp.length !== 0 && insuranceDataTemp[0].id !== undefined && insuranceDataTemp[0].id !== "")
            insuranceId = insuranceDataTemp[0].id 
        
            let newArr = [];
            if(insuranceData !== undefined && insuranceData !== null && insuranceData !== []  && insuranceData.length !== 0)
            {
                newArr.push(...insuranceData.map(obj => ({...obj})));
                let isIdMatch = false;
                newArr.forEach((item,index)=>{
                    if(item.id !==undefined && item.id !=="" && item.id === insuranceId && insuranceDataTemp[0]!==undefined && insuranceDataTemp[0] !== null && insuranceDataTemp[0] !=="")
                    {
                        newArr[index] = insuranceDataTemp[0];
                        isIdMatch = true;
                    }
                });
                if(!isIdMatch)
                    newArr.push(...insuranceDataTemp.map(obj => ({...obj})));
            }
            else{
                newArr.push(...insuranceDataTemp.map(obj => ({...obj})));
            }
        insuranceDataFormat=newArr;
        setInsuranceData(insuranceDataFormat)
        if(insuranceRef.current !== undefined )
            insuranceRef.current.resetInsuranceOnClickOfSubmit()
        validateAndSave();
    }

    const formatJsonAndSave = () => {
        setIsLoading(true);
        
        let allDataObject = {
            "basicInfoData":basicInfoData, 
            "addressData":addressData, "contactData":contactDataFormat,
            "insuranceData":insuranceDataFormat
        }
         
        requestJSON = setAllDataInJson(allDataObject,requestJSON);
        console.debug("requestJSON", requestJSON)
           
        pwrService.savePatientData(requestJSON).subscribe(res=>{
            console.debug("res",res)
            if(validationPopupRef.current !== undefined && res !== undefined && res !== null && res.status !== undefined && res.status !== "")
            {
                validationPopupRef.current.getResponse(res.status,null)
            }
            else{
                ToastMessageNotification(toastMessages.INTERNAL_ERROR_OCCUR);
            }
        });

    }

    return (<>
        {isLoading ? <div className="overlay"><div className="loader v-center"></div></div> : null}
        <section className="app-wrapper">
            <Header />
            <div className="tds-patient-registration">

            <div className="tds-adderss-alert-msg">
                <ToastContainers />
            </div>

            <ValidationPopup ref={validationPopupRef} setIsLoading={setIsLoading}/>
               
                    <div className="container-fluid">
                        <div className="row">
                            <div className="card">
                                <div className="card-header">
                                    <h2><span><i className="fa fa-user-plus" aria-hidden="true"></i></span> Patient Registration</h2>
                                    <div className="tds-header-btn">
                                        <OverlayTrigger placement={"bottom"} overlay={submitIconTooltip}>
                                            <button className="btn btn-blue ml15" onClick={formatContactData}>Submit</button>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <BasicInfoTab setBasicInfoData={setBasicInfoData} ref={basicInfoRef}/>
                                    <Address setAddressData={setAddressData} ref={addressRef}/>
                                    <Contact contactData={contactData} setContactData={setContactData} setContactDataTemp={setContactDataTemp} ref={contactRef}/>
                                    <InsuranceTab insuranceData={insuranceData} setInsuranceData={setInsuranceData} setInsuranceDataTemp={setInsuranceDataTemp} ref={insuranceRef}/>
                                    <div className="tds-wrapper-btn">
                                        <OverlayTrigger placement={"bottom"} overlay={submitIconTooltip}>
                                            <button className="btn btn-blue ml15" onClick={formatContactData}>Submit</button>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
            </div>
            <Footer />
          
        </section>
    </>
    )
}

export default withRouter(PatientRegistration);